export function setStyle(element: HTMLElement, style?: Partial<CSSStyleDeclaration>) {
  if (!style) {
    return element;
  }

  Object.assign(element.style, style);
  return element;
}
